import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import SelectAsync from './../../../FormTemplate/SelectAsync';

class RenderInventoryCounterList extends React.Component {
   render() {
      const { fields } = this.props;
      return (
         <div>
            <Table>
               <thead>
               <tr>
                  <th>SL.</th>
                  <th>Items</th>
                  <th>Unit Gain</th>
                  <th>Predicted Price</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td>
                        {index + 1}
                     </td>
                     <td className="col-md-8" >
                        <Field
                           name={`${item}.item_id`}
                           type="text"
                           minimumInput={1}
                           link="gainAdjustment/searchItemByName"
                           component={SelectAsync} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.unit`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.price`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td>
                        <Button onClick={() => fields.remove(index)} >x</Button>
                     </td>
                  </tr>
               )}
               </tbody>
            </Table>
            <Button onClick={() => fields.push({})} >Add Item</Button>
         </div>
      );
   }
}

RenderInventoryCounterList.propTypes = {
   fields: PropTypes.object,
   items: PropTypes.array
};

export default RenderInventoryCounterList;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/GainAdjustment/FormHelper/RenderItemList.js
 **/